import { STATS, COLORS } from "@/data/siteData";
import { Reveal } from "./Reveal";

export const StatStrip = ({ dark = false }) => {
  return (
    <div
      data-testid="stat-strip"
      className={`flex flex-wrap items-center justify-center gap-x-10 gap-y-6 py-4 ${dark ? "text-white" : "text-[#1A1A1A]"}`}
    >
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08} className="text-center">
          <div className="font-extrabold text-3xl sm:text-4xl" style={{ color: dark ? "#F48FB1" : COLORS[i % COLORS.length] }}>{s.value}</div>
          <div className={`mt-1 text-xs uppercase tracking-[0.15em] font-mono ${dark ? "text-white/60" : "text-gray-500"}`}>
            {s.label}
          </div>
        </Reveal>
      ))}
    </div>
  );
};
